import PlaySVG from '@public/icons/play.svg';
import classNames from 'classnames';
import { forwardRef, useEffect, useRef, useState } from 'react';
import Image from '@/shared/components/shared/Image';
import { ImageShape, VideoShape } from '@/shared/lib/types';
import Responsive from '../Responsive';
import Video from '../Video';

export type AppConstructorVideoCard = {
    title?: string | null;
    video: VideoShape;
    image?: ImageShape | null;
};

type Props = React.HTMLAttributes<HTMLElement> & AppConstructorVideoCard;

const ConstructorVideoCard = forwardRef<HTMLDivElement, Props>(({ title, video, image, ...props }, ref) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [hasBeedPlayed, setHasBeedPlayed] = useState(false);
    const videoRef = useRef<HTMLVideoElement>(null);

    const handlePlayClick = () => {
        setIsPlaying(!isPlaying);
    };

    useEffect(() => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.play();
            } else {
                videoRef.current.pause();
            }
        }
    }, [isPlaying]);

    return (
        <Responsive
            ref={ref}
            {...props}
            tag="a"
            href="#"
            role="button"
            className={classNames('video-constructor-wrapper', props.className)}
            onClick={(event) => {
                event.preventDefault();
                handlePlayClick();
                setHasBeedPlayed(true);
            }}
        >
            <div>
                {image?.src && !hasBeedPlayed ? (
                    <Image
                        src={image.src}
                        width={image.width}
                        height={image.height}
                        alt={image.alt || title || ''}
                        title={image.title}
                        sizes="100vw"
                        className="responsive__item constructor-video-content"
                    />
                ) : (
                    <Video
                        ref={videoRef}
                        className="responsive__item constructor-video-content constructor-video-content__video"
                        loop
                        playsInline
                        sources={video}
                        previewImg={image}
                        previewImgSizes="100vw"
                    />
                )}
                <span className="video-play-btn">{!isPlaying && <PlaySVG width={60} height={60} />}</span>
            </div>
        </Responsive>
    );
});

ConstructorVideoCard.displayName = 'ConstructorVideoCard';

export default ConstructorVideoCard;
